export const validations_ru = {
  messages: {
    _default: "Блаблабла",
    after: "",
    alpha_dash: "Поле должно содержать только буквы, цифры и дефис.",
    alpha_num: "Поле должно содержать только буквы и цифры.",
    alpha_spaces: "Поле должно содержать только буквы и пробелы.",
    alpha: "Поле должно содержать только буквы.",
    before: "",
    between: "",
    confirmed: "Поля не совпадают",
    credit_card: "",
    date_between: "",
    date_format: "",
    decimal: "",
    digits: "",
    dimensions: "",
    email: "Поле должно соответствовать маске example@mail.ru",
    ext: "",
    image: "",
    in: "",
    ip: "",
    max: "",
    max_value: "",
    mimes: "",
    min: "Слишком короткое значение",
    min_value: "Блаблабла",
    not_in: "",
    numeric: "",
    regex: "",
    required: "Поле не может быть пустым",
    size: "",
    url: "",
    alphaKaz: 'Только русские и казахские символы',
    alphaKazNum: 'Только цифры, русские и казахские символы',
    phoneOrEmail: 'Данные введены неверно'
  }
};
export const validations_kz = {
  messages: {
    _default: "Блаблабла каз",
    after: "",
    alpha_dash: "",
    alpha_num: "",
    alpha_spaces: "",
    alpha: "",
    before: "",
    between: "",
    confirmed: "Ошибка всех ошибок 1",
    credit_card: "",

    date_between: "",
    date_format: "",
    decimal: "",
    digits: "",
    dimensions: "",
    email: "Поле должно соответствовать маске example@mail.ru",
    ext: "",
    image: "",
    in: "",
    ip: "",
    max: "",
    max_value: "",
    mimes: "",
    min: "каз мин вал",
    min_value: "каз мин вал",
    not_in: "",
    numeric: "",
    regex: "",
    required: "test kz",
    size: "",
    url: "",
      alphaKaz: 'Только русские и казахские символы',
      alphaKazNum: 'Только цифры, русские и казахские символы',
      phoneOrEmail: 'Данные введены неверно'
  }
};
